<template>
	<v-form ref="form" v-model="isFormValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			:max-width="modalOptions.largura"
			:is-confirmar-desabilitado="!isFormValid"
			@close="fecharModal"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			:is-confirmar-visivel="isConfirmarVisivel()"
		>
			<template #body>
				<v-row class="mt-1 mb-2">
					<v-col cols="12">
						<label-personalizado
							nome-campo="Descrição Ocorrência"
							obrigatorio-por-padrao
							class="mb-2"
						></label-personalizado>
						<v-textarea
							ref="descricao"
							v-model="descricao"
							placeholder="Informe a descrição da ocorrência"
							:rules="regras"
							rows="7"
							counter="4000"
							class="ma-0 py-0"
							no-resize
							@input="corrigirTexto"
						></v-textarea>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import BotaoCancelar from '@/views/components/BotaoCancelar.vue'
import Modal from '@/views/components/Modal.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'

export default {
	name: 'modal-inserir-ocorrencia',
	components: { LabelPersonalizado, Modal, BotaoCancelar, BotaoPrimario },
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		labelAcaoCancelar: {
			type: String,
			default: 'NÃO',
		},
		tituloModal: {
			type: String,
			required: true,
		},
		mostrarAcaoConfirmar: {
			type: Boolean,
			default: true,
		},
	},
	emits: ['fechar-modal', 'confirmar'],
	data() {
		return {
			isFormValid: false,
			modalOptions: {
				largura: '1076',
				altura: '1600',
			},
			descricao: '',
			regras: [
				(value) => this.regraObrigatoriedade(value, 'A descrição é obrigatória.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						4000,
						'O campo de descrição deve ser igual ou menor que 4000 caracteres!',
					),
			],
		}
	},
	beforeDestroy() {
		this.limparCampo()
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		async confirmar() {
			if (this.$refs.form.validate()) {
				await this.$emit('confirmar', this.descricao)
			}
		},
		corrigirTexto() {
			if (this.descricao) {
				this.descricao = this.descricao.trim()
			}
		},
		isConfirmarVisivel() {
			return this.descricao && this.isFormValid
		},
		limparCampo() {
			this.descricao = ''
		},
	},
}
</script>

<style lang="stylus" scoped>
.v-dialog
	.texto-titulo
		color #404040
		width 98%
		text-align center
		margin-left 18px
		margin-right 17px
		font-weight 700
		font-size 22px
		line-height 26px

	.close-modal-mobile
		position absolute !important
		right 20px !important

	.mensagem-modal
		display grid !important

	.v-card__title
		word-break break-word

	.texto-corpo
		color #4B4B4B
		font-size 18px
		font-weight 400
		text-align center
		font-style normal
		line-height 25px

	.texto-confirmacao
		color #726f6f
		font-size 18px
		font-weight 400
		text-align center
		font-style normal
		line-height 25px
</style>
